import type { TRuleWithTheme } from '@/styles/theme';

export const pageContainer: TRuleWithTheme = () => ({
    width: '100%',
});

export const contentContainer: TRuleWithTheme = () => ({
    paddingBlock: '2rem',
    paddingInline: '1rem',

    // To prevent the chat button from overlapping the content
    paddingBottom: '8rem',

    min1024: {
        paddingBlock: '3rem',
        paddingInline: '4.25rem',
    },
});
